import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import type { SanityImage } from '@time-line/components/types';
import { useImage } from 'lib/sanity';
import Image from 'next/image';
import Link from 'next/link';

interface ResultLayoutProps {
  href: string;
  title: string;
  type?: string;
  image?: SanityImage;
  onNavigate?: () => void;
}

export function ResultLayout({
  href,
  title,
  type,
  image,
  onNavigate,
}: ResultLayoutProps) {
  const imageProps = useImage(image || null, { ratio: 1 });

  return (
    <Box
      as="article"
      _last={{
        '> *': {
          borderBottomWidth: 0,
          pb: 'sm',
        },
      }}
    >
      <Flex
        as={Link}
        href={href}
        borderBottomWidth={1}
        borderColor="blackAlpha.250"
        py="2xs"
        justifyContent="space-between"
        alignItems="center"
        gap="2xs"
        transition="opacity 0.2s ease-in-out 0s"
        _hover={{
          opacity: 0.8,
        }}
        onClick={onNavigate}
      >
        <Stack gap="4xs">
          {type && (
            <Text size="overline" color="blackAlpha.700">
              {type}
            </Text>
          )}
          <Text as="h2" size="title">
            {title}
          </Text>
        </Stack>
        {imageProps && (
          <Box borderRadius="base" overflow="hidden" flexShrink={0}>
            <Image
              {...imageProps}
              width={80}
              height={80}
              alt={image?.alt || title}
              sizes="80px"
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
}
